export default function (axios) {
  return {
    //申请试用列表
    getApplyTrialList(data) {
      return axios.post("/anon/applyTrial/selectCompTrialList", data, {
        conType: "application/json;",
        showLoading: false,
      });
    },

    //保存审批情况
    saveApplyTrialApp(data) {
      return axios.post("/anon/applyTrial/approveTrial", data, {
        conType: "application/json;",
        showLoading: false,
      });
    },

    //保存申请试用的信息
    addApplyTryNose(params) {
      // return axios.post("/applyTry/addApplyTryNose", params);
      return axios.post("/anon/applyTrial/submitApplication", params);
    },

    //查找公司名是否重复
    compNameRepeat(params) {
      return axios.post("/anon/applyTrial/selectCompNameExist", {}, { params }); 
    },

  };
}
